import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  websiteTargetList: [],
  microTargetList: [],
  selectedSharedUid: null,
  selectedSite: null,
  siteOptions: [],
  page: 0,
  selectedPeriod: null,
  selectedDataSet: 'Key Metrics',
};


const websiteTargetSlice = createSlice({
  name: 'websiteTarget',
  initialState: initialState,
  reducers: {
    setWebsiteTargetList: (state, action) => {
      state.websiteTargetList = action.payload;
    },
    setMicroTargetList: (state, action) => {
      state.microTargetList = action.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setSelectedSharedUid: (state, action) => {
      state.selectedSharedUid = action.payload;
    },
    setSiteOptions: (state, action) => {
      state.siteOptions = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSelectedPeriod: (state, action) => {
      state.selectedPeriod = action.payload;
    },
    setSelectedDataSet: (state, action) => {
      state.selectedDataSet = action.payload;
    }
  }
});

export const { setWebsiteTargetList, setMicroTargetList, setSelectedSite, setSelectedSharedUid, setSiteOptions, setPage, setSelectedPeriod, setSelectedDataSet } = websiteTargetSlice.actions;
export default websiteTargetSlice.reducer;

